import { observer } from "mobx-react";
import { useEffect } from "react";
import { Colors, Display } from "Views/Components/Button/Button";
import ButtonAsyncState from "Views/Components/Button/ButtonAsyncState";
import { ButtonGroup } from "Views/Components/Button/ButtonGroup";
import CheckboxSetter from "Views/Components/Checkbox/CheckboxSetter";
import EntityList from "Views/Components/EntityList/EntityList";
import TablePagination from "Views/Components/Pagination/TablePagination";
import { Tooltip } from "Views/Components/Tooltip/Tooltip";
import { useAppSettingStore } from "../SettingStores/AppSettingPageStore";

interface Props {
	providerId: string;
}

export const OrganisationProviderList: React.FunctionComponent<Props> = observer(({
	providerId,
}) => {
	const { organisationProviderStore } = useAppSettingStore();

	useEffect(() => {
		if (!!providerId) {
			organisationProviderStore.setProviderId(providerId);
		}

		return () => {
			organisationProviderStore.reset();
		}
	},[providerId, organisationProviderStore]);

	return (
		<>
			<ButtonGroup>
				<ButtonAsyncState
					colors={Colors.Primary}
					display={Display.Solid}
					onPress={async () => {
						await organisationProviderStore.toggleAll(true);
					}}
					readonly={organisationProviderStore.bulkActionLoading}
				>
					Enable all
				</ButtonAsyncState>
				<ButtonAsyncState
					colors={Colors.Error}
					display={Display.Outline}
					readonly={organisationProviderStore.bulkActionLoading}
					onPress={async () => {
						await organisationProviderStore.toggleAll(false);
					}}
				>
					Disable all
				</ButtonAsyncState>
			</ButtonGroup>
			<div className="collection-component">
				<EntityList
					collection={organisationProviderStore.organisationProviders}
					columns={[
						{
							displayName: "Organisation Provider Id",
							columnName: "organisationProviderId",
							value: item => item.organisationProviderId,
							className: "field-organisationProviderId",
							hide: true,
						},
						{
							displayName: "Organisation Name",
							columnName: "organisationName",
							value: item => item.organisationName,
							className: "field-organisationName",
						},
						{
							displayName: <>Enabled <Tooltip
								id="isEnabled"
								content="Toggling this will enable or disable all provider products across an organisation, overwriting their current states.</br>Checked indicates all are enabled.</br>Unchecked indicates at least one is not enabled."
							/></>,
							columnName: "enabled",
							value: item => (
								<CheckboxSetter
									value={item.isLinked}
								/>
							),
							onClickValue: item => organisationProviderStore.updateOrganisationProviderLink(item.organisationId, !item.isLinked),
						}
					]}
					idColumn="organisationId"
					sortColumn="organisationName"
					sortDescending
				/>
				<TablePagination
					perPage={organisationProviderStore.pageSize}
					pageNo={organisationProviderStore.pageNo - 1}
					totalRecords={organisationProviderStore.totalCount}
					onPageChange={pageNo => organisationProviderStore.setPageNo(pageNo + 1)}
				/>
			</div>
		</>
	)
});